import { render, staticRenderFns } from "./ProductsReport.vue?vue&type=template&id=63670e94&"
import script from "./ProductsReport.vue?vue&type=script&lang=js&"
export * from "./ProductsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports